module.exports = __webpack_public_path__ + "img/grocery-shopping-recipes.e9a375bc.jpg";